import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent {
  options = {
    position: ["bottom", "right"],
    timeOut: 3000,
    lastOnBottom: true
  }
    

 }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/containers/full-layout/full-layout.component.ts